<template>
  <div class="mc-liveview--temp">
    <template v-if="$apollo.loading">
      <div class="__loading">
        <b-spinner />
        <strong>Loading...</strong>
      </div>
    </template>
    <template v-else>
      <template v-if="!isExpired">
        <div
          :class="{
            'card mc-liveview clearfix': $store.state.sidebar.sideBarOpen === true,
            'card mc-liveview clearfix close-sidebar': $store.state.sidebar.sideBarOpen === false,
          }"
        >
          <GoogleMap
            :temporary-live-view="temporaryLiveView && temporaryLiveView.temporaryLiveView"
          />
          <SideBar />

          <div
            v-if="!$store.state.fleets.autoReload"
            class="mc-notif-reload d-flex justify-content-between"
          >
            <p>
              <i class="mc-fa icon-outline_alert-triangle"></i> {{ $t('global.text.reloadIsOff') }}
            </p>
            <a class="text-primary" @click="active">{{ $t('global.action.reactivate') }}</a>
          </div>
        </div>
        <NotificationWaModal />
      </template>
      <template v-else>
        <div class="mc-livetrack-expired">
          <img :src="require('@/assets/images/temp-tracking/expired-link.svg')" width="300px" />
          <div class="title">Batas Aktif Tautan Pelacakan Sudah Habis</div>
          <div class="subtitle">Terimakasih sudah menggunakan jasa kami.</div>
        </div>
      </template>
    </template>
    <div v-if="!isExpired && expiresOn" class="mc-liveview--temp-footer py-4 clearfix">
      <div v-if="!$store.state.whitelabel.checkDomainShow" class="float-end">
        <span
          class="me-3"
          :hidden="
            getAsset('copyrightLogo', 'general') == null ||
            getAsset('copyrightLogo', 'general') == ''
          "
          >{{ $t('global.text.poweredBy') }} :
        </span>
        <figure class="d-inline-block mb-0">
          <img ref="imgCopyrightLogo" :src="getAsset('copyrightLogo', 'general')" alt />
        </figure>
      </div>
      <p class="text-center mb-0">
        {{ $t('global.text.pageAvailable') }} {{ expiresOn }} ({{ $t('global.text.remaining') }}
        {{ expiresDays }} {{ $t('global.time.days') }}).
      </p>
    </div>
  </div>
</template>

<script>
import appConfig from '@/app.config'
import { LOGIN_ERROR_MESSAGE } from '@/helpers/errorHandler'
import { TRACKING_TEMPORARY_DETAIL } from '@/services/api/trackingTemporary/temporary'
import GoogleMap from './GoogleMap'
import SideBar from './SideBar'
import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'
import { MixPanel } from '@/mixin/mixpanel'

import NotificationWaModal from '../components/NotificationWaModal'

export default {
  name: 'LiveView',
  page: {
    title: 'Pelacakan Sementara',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    SideBar,
    GoogleMap,
    NotificationWaModal,
  },
  mixins: [Helper, MixPanel],
  apollo: {
    temporaryLiveView: {
      query: TRACKING_TEMPORARY_DETAIL,
      variables() {
        return {
          filter: {
            temporaryLvId: parseInt(this.id),
          },
        }
      },
      result({ data, loading }) {
        if (!loading) {
          if (!data.temporaryLiveView.isSuccessful) {
            this.markAsExpired()
            return
          }

          var param = window.location.search
          const urlParams = new URLSearchParams(param)

          const token = urlParams.get('token')

          if (token && token != data.temporaryLiveView.temporaryLiveView.accessToken) {
            this.markAsExpired()
            return
          }

          this.accessToken = data.temporaryLiveView.temporaryLiveView.accessToken

          this.expiresOn =
            this.momentDateShortMonth(data.temporaryLiveView.temporaryLiveView.expiresOn) +
            ' - ' +
            this.momentTimeSeconds(data.temporaryLiveView.temporaryLiveView.expiresOn)
          this.expiresDays = this.calculateDay(
            data.temporaryLiveView.temporaryLiveView.expiresOn,
            new Date()
          )

          this.$store.commit(
            'map/SET_VEHICLEIDS',
            data.temporaryLiveView.temporaryLiveView.vehicleIds.map((item) => item.vehicleId)
          )
          this.$store.commit(
            'map/SET_PICKED_COLUMNS',
            data.temporaryLiveView.temporaryLiveView.pickedColumns
          )
        }
      },
      error(error) {
        if (this.isExpiredTemporaryLiveViewError(error)) {
          this.markAsExpired()
        }
      },
    },
  },
  data() {
    return {
      isExpired: false,
      id: this.$route.params.id || null,
      expiresDays: null,
      expiresOn: null,
      host: window.location.host,
      isVisible: false,
      accessToken: this.$route.query.token || null,
    }
  },
  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
      getFeatureFlagData: 'identity/getFeatureFlagData',
    }),

    isNotificationLocationFlagEnabled() {
      return this.getFeatureFlagData('notification.temporary_track').value
    },
  },
  watch: {
    accessToken(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.replaceQueryParam(newVal)
      }
    },
  },
  async created() {
    this.$store.commit('map/TYPE_OF_MAP', 'fleet')

    const data = {
      zoom: 5.56,
      open: false,
      gmp: null,
      type: 'fleet',
    }

    this.$store.dispatch('map/setCENTER', data)

    this.$root.$on('bv::modal::show', (bvEvent) => {
      if (bvEvent.componentId === 'select_options_temp') {
        this.$bvModal.hide('modal-info-temp')
      } else if (bvEvent.componentId === 'modal-info-temp') {
        this.$bvModal.hide('select_options_temp')
      }
    })

    let timer = setInterval(() => {
      if (window.fcWidget) {
        if (document.getElementById('custom_fc_button'))
          document.getElementById('custom_fc_button').style.visibility = 'hidden'
        clearInterval(timer)
      }
    }, 300)
  },
  mounted() {
    let domainName = '-'

    const hostname = window.location.hostname
    const domainParts = hostname.split('.')

    if (domainParts.length > 2) {
      domainName = domainParts[0]
    }

    const tempTrackId = this.$route.params.id ?? '-'
    const tempTrackToken = this.$route.query.token ?? '-'

    this.track('View Temporary Live Track', {
      App: 'vsms',
      'App Platform': 'web',
      env: process.env.VUE_APP_ENV,
      company_domain_name: domainName,
      temporary_track_id: tempTrackId,
      temporary_track_token: tempTrackToken,
    })

    this.adjustImageSize()

    if (!this.isNotificationLocationFlagEnabled) {
      // for handling modal pop up notification wa
      var showedNotifyMeTempTrack =
        JSON.parse(localStorage.getItem('showedNotifyMeTempTrack')) || {}

      if (showedNotifyMeTempTrack[this.$route.params.id]) return
      setTimeout(() => {
        this.$bvModal.show('notification-wa-modal')
      }, 5000)
    }
  },
  methods: {
    markAsExpired() {
      this.isExpired = true
      this.expiresDays = null
      this.expiresOn = null
    },
    isExpiredTemporaryLiveViewError(error) {
      const errorMessage = error?.toString() || ''
      const networkStatusCode = error?.networkError?.statusCode ?? error?.networkError?.status
      const hasAuthGraphQLError = error?.graphQLErrors?.some(
        ({ extensions, message }) =>
          extensions?.code === 'UNAUTHENTICATED' ||
          extensions?.code === 'INTERNAL_SERVER_ERROR' ||
          message === LOGIN_ERROR_MESSAGE
      )

      return (
        hasAuthGraphQLError ||
        networkStatusCode === 401 ||
        networkStatusCode === 500 ||
        errorMessage.includes('401') ||
        errorMessage.includes('500')
      )
    },
    replaceQueryParam(newVal) {
      this.$router.replace({ name: 'Tracking Temporary Liveview', query: { token: newVal } })
      setTimeout(() => {
        location.reload()
      }, 1000)
    },
    adjustImageSize() {
      this.resizeImage(this.$refs.imgPrimaryLogo, 40, 125)
      this.resizeImage(this.$refs.imgCopyrightLogo, 40, 125)
    },
  },
}
</script>
